module.exports = __webpack_public_path__ + "img/GAME_BLOCKFLIP2.fcb12a1f.jpg";